import { lazy } from 'react';
import NotFoundPage from '../views/not_found/not_found.view.js';
import MinimalLayout from '../layouts/MinimalLayout/index.js';
import { Navigate } from 'react-router-dom';
import { isEnabled } from '../config/features';

/****Layouts*****/
const AdminOrdersPage = lazy(() => import('../views/admin/AdminOrdersPage.js'));
const PromoCheckPage = lazy(() => import('../views/promo/PromoCheckPage'));
const HomePage = lazy(() => import('../views/home/HomePage.js'));
const LeadsPage = lazy(() => import('../views/leads/LeadsPage.js'));
const CodesPage = lazy(() => import('../views/codes/CodesPage.js'));
const ProgramOverviewPage = lazy(() => import('../views/codes/ProgramOverviewPage.js'));
const AttributionGapsPage = lazy(() => import('../views/codes/AttributionGapsPage.js'));
const AmoRulesPage = lazy(() => import('../views/amo-rules-page/amo-rules-page.jsx'));
const AmoRuleEditorPage = lazy(() => import('../views/amo-rules-page/amo-rule-editor-page.jsx'));
const AmoRuleClientsPage = lazy(() => import('../views/amo-rules-page/amo-rule-clients-page.jsx'));
const AmoRuleErrorLogsPage = lazy(() => import('../views/amo-rules-page/amo-rule-error-logs-page.jsx'));
const AmoAnalyticsPage = lazy(() => import('../views/amo-rules-page/amo-analytics-page.jsx'));
const AmoCallsPage = lazy(() => import('../views/amo-rules-page/amo-calls-page.jsx'));
const AmoCallsSettingsPage = lazy(() => import('../views/amo-rules-page/amo-calls-settings-page.jsx'));
const AmoDealsSearchPage = lazy(() => import('../views/amo-rules-page/amo-deals-search-page.jsx'));
const AmoDedupPage = lazy(() => import('../views/amo-rules-page/amo-dedup/amo-dedup-page.jsx'));
const AmoReconcilePage = lazy(() => import('../views/amo-reconcile/ReconcilePage.jsx'));
const UsersPage = lazy(() => import('../views/users/UsersPage.js'));
const AllChatsPage = lazy(() => import('../views/chats/AllChatsPage.js'));
const SettingsPage = lazy(() => import('../views/settings/SettingsPage.js'));
const ProfilePage = lazy(() => import('../views/profile/ProfilePage.js'));
const AuditLogPage = lazy(() => import('../views/users/AuditLogPage.js'));


/**
 * Роут выключенного раздела (см. src/config/features.js) не удаляем, а уводим на
 * главную: страница остаётся в коде, прямой заход по адресу никуда не приводит.
 * Вернуть раздел = поставить флаг в true здесь и на бэке.
 */
const gated = (feature, element) => (isEnabled(feature) ? element : <Navigate to='/home' replace />);

const ThemeRoutesFullLayout = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/',
      element: <Navigate to='/home' replace />,
    },
    { path: 'login', element: <Navigate to='/home' replace /> },
    { path: 'register', element: <Navigate to='/home' replace /> },
    { path: 'admin', element: <AdminOrdersPage /> },
    { path: 'promo', element: <PromoCheckPage /> },
    { path: 'home', element: <HomePage /> },
    { path: 'leads', element: <LeadsPage /> },
    { path: 'codes', element: <CodesPage /> },
    { path: 'promo-overview', element: <ProgramOverviewPage /> },
    { path: 'attribution-gaps', element: <AttributionGapsPage /> },
    { path: 'amo/rules', element: gated('amo', <AmoRulesPage />) },
    { path: 'amo/rules/new', element: gated('amo', <AmoRuleEditorPage />) },
    { path: 'amo/rules/:id/edit', element: gated('amo', <AmoRuleEditorPage />) },
    { path: 'amo/rules/:id/clients', element: gated('amo', <AmoRuleClientsPage />) },
    { path: 'amo/rules/:id/logs', element: gated('amo', <AmoRuleErrorLogsPage />) },
    { path: 'amo/analytics', element: gated('amo', <AmoAnalyticsPage />) },
    { path: 'amo/calls', element: gated('amo', <AmoCallsPage />) },
    { path: 'amo/calls/settings', element: gated('amo', <AmoCallsSettingsPage />) },
    { path: 'amo/deals-search', element: gated('amo', <AmoDealsSearchPage />) },
    { path: 'amo/duplicates', element: gated('amo', <AmoDedupPage />) },
    { path: 'amo/reconcile', element: gated('amo', <AmoReconcilePage />) },
    { path: 'users', element: <UsersPage /> },
    { path: 'users/audit', element: <AuditLogPage /> },
    { path: 'profile', element: <ProfilePage /> },
    { path: 'chats', element: gated('chats', <AllChatsPage />) },
    { path: 'settings', element: <SettingsPage /> },
    { path: '*', element: <NotFoundPage /> },
  ],
};

export default ThemeRoutesFullLayout;
